import React from "react";
import { Hero, PageContent } from "../../components";

function Contribution() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col z-8">
      <Hero title={"Contribution"}>
        Individually, we are drops; together,{" "}
        <span className="text-lg font-black text-BleuClair md:text-xl lg:text-2xl">
          we are an ocean.
        </span>
      </Hero>

      <PageContent>
        {`  
# Project Inspiration

When we were brainstorming and researching for our project, looking at what other iGEM teams had done served as a real source of inspiration. We made sure that our project was meaningful and would provide future teams with valuable insights and resources.

## Diverse Contributions

For our contribution, we ensured diversity in the help we offered, spanning from wet lab experiments to dry lab analysis and educational materials.

### New Registry Parts

We have designed the following new basic and composite parts for the [registry](https://parts.igem.org/cgi/partsdb/pgroup.cgi?pgroup=iGEM2023&group=Ionis-Paris):

We hope that these new basic and composite parts will enable the iGEM and SynBio communities to utilize them for new studies.

## Experiments and Protocols

### Experiments on *C. reinhardtii* and *S. meliloti* adaptation

Through our research, we discovered that *C. reinhardtii* and *S. meliloti* could thrive in wastewater and even possess natural properties to depollute it. We developed protocols to gradually adapt them to synthetic versions of these media. Our experiments ([link to Notebook](https://2023.igem.wiki/ionis-paris/project/notebook)) and open-source protocols ([link to Experiments](https://2023.igem.wiki/ionis-paris/project/experiments)) could assist future iGEM teams interested in wastewater and urine revalorization.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/contribution/graph.jpg">
</div>

### Co-culture of *C. reinhardtii* and *S. meliloti*

In our quest, we explored existing co-culture assays in the literature. However, we encountered challenges in growing *C. reinhardtii* and *S. meliloti* together, as the bacteria outcompeted the microalgae. Our most viable solution involved centrifugating the co-culture, similar to the fed batch method in a photobioreactor. We believe that our co-culture experiments ([link to Notebook](https://2023.igem.wiki/ionis-paris/project/notebook)), with various modified parameters, could prove beneficial for future iGEM teams.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/contribution/graph-coculture.jpg">
</div>

## Innovative Photobioreactor

We've developed an open-source photobioreactor ([link to Hardware](https://2023.igem.wiki/ionis-paris/hardware)) designed to conduct heat, which is a groundbreaking concept! The main part of the photobioreactor has been 3D printed, allowing space for components such as insulation cork, sensors, lighting, and a bubbler. The reactor's conductivity is represented by a metallic wire, which can be replaced with a copper pipe. We are highly optimistic that this photobioreactor could be of immense support for projects focused on creating bio-based heat.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/contribution/hardware.jpg">
</div>

## Educational Endeavors

### Open-Sourced Board Game

The Ionis Paris team shares a passion for board games, so naturally, we created a trivia board game ([link to Education](https://2023.igem.wiki/ionis-paris/education)) about synthetic biology. Inspired by the game 'Tu te mets combien?' (How Much Do You Know?), our game covers various levels of general knowledge about history, techniques, microorganisms, plants, and safety. We thoroughly enjoyed creating and playing it with students from our school and local residents in Villejuif. We believe this open-source game could be incredibly useful for future iGEM teams looking to make biology discovery entertaining.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/contribution/boardgame.jpg">
</div>

### Open-Source Mobile Game: Plasmide

Finally, we've developed a mobile game ([link to Education](https://2023.igem.wiki/ionis-paris/education)) called "Plasmide" that turns your phone into a pocket-sized lab. This game allows players to integrate specific genes or symptoms into a plasmid to recreate an existing bacterium. It offers a fun way to explore bacteria, understand their related risks, and delve into synthetic biology. However, we didn't have the time to test it with a diverse population to ensure accessibility. 

<div class="image_frame horizontal no_wrap">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/contribution/appli-1.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/contribution/appli-2.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/contribution/appli-3.jpeg">
</div>

We highly encourage future iGEM teams to use the open-source mobile game, test it, and improve it to further our initiative in facilitating the discovery of synthetic biology.

          
          `}
      </PageContent>
    </div>
  );
}

export default Contribution;
